import React from "react";
import { useNavigate } from "react-router-dom";

const Chat = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <main className="container mx-auto p-6">
        <section className="mb-8 overflow-hidden rounded-3xl bg-gradient-to-r from-slate-900 via-slate-800 to-cyan-900 text-white shadow-sm">
          <div className="p-8 md:p-10">
            <p className="mb-3 inline-flex rounded-full bg-white/10 px-3 py-1 text-sm font-medium text-cyan-100">
              Dashboard Support
            </p>

            <h1 className="mb-3 text-3xl font-bold md:text-4xl">
              Chat support
            </h1>

            <p className="max-w-2xl text-sm leading-7 text-slate-200 md:text-base">
              Gérez les demandes des utilisateurs connectés, consultez les
              conversations actives et accédez à l’historique des tickets
              clôturés depuis une interface dédiée.
            </p>
          </div>
        </section>

        <section className="mb-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-sm transition hover:shadow-md">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-cyan-500/15 text-2xl">
              💬
            </div>

            <h2 className="mb-2 text-xl font-semibold text-white">
              Voir les tickets ouverts
            </h2>

            <p className="mb-6 text-slate-400">
              Consultez les conversations actuellement actives, ouvrez un ticket
              utilisateur, répondez en direct depuis le dashboard et suivez les
              échanges en cours.
            </p>

            <button
              onClick={() => navigate("/dashboard/chat/open")}
              className="rounded-xl bg-cyan-600 px-5 py-3 font-semibold text-white transition hover:bg-cyan-500"
            >
              Ouvrir les tickets actifs
            </button>
          </div>

          <div className="rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-sm transition hover:shadow-md">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-700/70 text-2xl">
              🕘
            </div>

            <h2 className="mb-2 text-xl font-semibold text-white">
              Historique des tickets fermés
            </h2>

            <p className="mb-6 text-slate-400">
              Parcourez les anciennes demandes support clôturées, consultez les
              échanges archivés et gardez une trace claire des tickets déjà
              traités.
            </p>

            <button
              onClick={() => navigate("/dashboard/chat/history")}
              className="rounded-xl bg-slate-700 px-5 py-3 font-semibold text-white transition hover:bg-slate-600"
            >
              Voir l’historique
            </button>
          </div>
        </section>

        <section className="rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-sm">
          <h2 className="mb-3 text-lg font-semibold text-white">
            À propos de ce module
          </h2>

          <p className="leading-7 text-slate-400">
            Cette section centralise la gestion du support utilisateur du site.
            Elle permet de distinguer les conversations en cours des tickets
            clôturés, de garder un historique clair des échanges et de préparer
            une structure évolutive pour la suite du projet, notamment avec la
            mise en place du temps réel et d’éventuelles notifications.
          </p>
        </section>
      </main>
    </div>
  );
};

export default Chat;